/**
 * @author NikolaV
 */
import { store } from '../store/rootStore';
import { latLonToEN } from '@openlayers/ol-utils';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import * as olStyle from 'ol/style';
import { mapWrapper } from '@pages/trucks/TrucksMap';
import { Events } from '@shared/Events';


let initialLoad = true;

const source: VectorSource = new VectorSource({
    features: [],
    useSpatialIndex: true,
});

const layer = new VectorLayer({
    source,
});

const styles = {
    1: new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: [0, 0, 0, 0.5],
            width: 2,
        }),
    }),
    2: new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: [0, 0, 0, 0.25],
            width: 3,
        }),
    }),
    3: new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: [0, 0, 0, 0.1],
            width: 4,
        }),
    }),
};

export function drawTrails() {
    if (initialLoad) {
        initialLoad = false;
        mapWrapper.addLayer(layer, 95, 'tails');
    }

    source.clear();
    Events.trigger('map-hide-overlays');

    store.vehicles.activeProjectVehicles.forEach(v => {
        if (v.positionHistory.length >= 2) { // todo v.positionHistory should be capped to size 4
            for (let i = 1; i < Math.min(v.positionHistory.length, 4); i++) {
                const curr = v.positionHistory[i];
                const prev = v.positionHistory[i - 1];

                const feature = new Feature({
                    geometry: new LineString([latLonToEN(curr.latitude, curr.longitude), latLonToEN(prev.latitude, prev.longitude)]),
                });
                feature.setStyle(styles[i]);
                source.addFeature(feature);
            }
        }
    });
}
